import styled, { CSSProp } from 'styled-components'

export const DropDownDialCodeUi = styled.span<{
  styles?: CSSProp
}>`
  color: gray;

  ${({ styles }) => styles}
`
